
import { useState } from "react";
import styles from "../FieldTypeModal.module.scss";
import { CirclePlusIcon, DeleteIcon, DragIndicatorIcon } from "../../../../../../../assets/icons";
import { ChoseBoolFiledConfig } from "./shared/ChooseBool";
import Button from "../../../../../../../common/components/xepp/button/Button";
import { InputWithClearFiledConfig } from "./shared/InputWithClear";
import { Attribute, FieldType, Option } from "../../../../../../../model/service-request/attribute";
import { v4 as uuidv4 } from 'uuid';

type Props = {
    onFieldSave: (attr: Attribute) => void
    existingAttribute?: Attribute
}

export const ConditionalDropdownFiledConfiguration = (props: Props) => {
    const [attribute, setAttribute] = useState<Attribute>({
        id: props.existingAttribute ? props.existingAttribute.id : uuidv4(),
        label: props.existingAttribute ? props.existingAttribute.label : "",
        isRequired: props.existingAttribute ? props.existingAttribute.isRequired :  false,
        isEnabled: props.existingAttribute ? props.existingAttribute.isEnabled :  true,
        displayOrder: props.existingAttribute ? props.existingAttribute.displayOrder :  1,
        childrenOptionDefinitions: props.existingAttribute ? props.existingAttribute.childrenOptionDefinitions :  [{ value: "", childOptions: [{ value: "" }, { value: "" }] }] as Option[],
        fieldType: FieldType.ConditionalDropdown,
    });

    const clearFieldName = () =>
        setAttribute({ ...attribute, label: "" });

    const addNewParentOption = () => {
        setAttribute({ ...attribute, childrenOptionDefinitions: [...attribute.childrenOptionDefinitions!, { value: "", childOptions: [{ value: "" }, { value: "" }] }] })
    }


    return <div>
        <div className={styles.configurationForm}>
            <InputWithClearFiledConfig
                onChange={(val: string) => {
                    setAttribute({ ...attribute, label: val })
                }}
                onClear={clearFieldName}
                filedLabel="Field Name"
                value={attribute.label}
                placeholederText="Enter Field Name"
            />

            <ChoseBoolFiledConfig
                onChange={(val: boolean) => {
                    setAttribute({ ...attribute, isRequired: val });
                }
                }
                value={attribute.isRequired ?? false}
                option1="Yes"
                option2="No"
                fieldLabel={"Required"}
            />

            <div className={styles.configurationField}>
                <div className={styles.title}>
                    <span className={styles.label}>Dropdown options</span>
                    <div className={styles.actionButton} onClick={addNewParentOption}>
                        <span className={styles.label}>Add Parent Option</span>
                        <CirclePlusIcon />
                    </div>
                </div>
                <div className={styles.body}>
                    {
                        attribute.childrenOptionDefinitions && attribute.childrenOptionDefinitions.map(
                            (parentOption, i) => {
                                return <div className={styles.parentOptionValue} key={`parent-option-${i}`}>
                                    <input
                                        type="text"
                                        value={parentOption.value}
                                        onChange={(e) => {
                                            parentOption.value = e.target.value;
                                            setAttribute({ ...attribute })
                                        }
                                        }
                                        placeholder={parentOption.value ? "" : `Enter Parent Option ${i + 1}`}
                                    />
                                    <div className={styles.subMenu}>
                                        {parentOption.childOptions && parentOption.childOptions.map((option, j) => {

                                            return <div className={styles.optionValue} key={`child-option-${j}`}>
                                                <div className={styles.dragInput}>
                                                    <DragIndicatorIcon className={styles.icon} />
                                                    <input
                                                        type="text"
                                                        value={option.value}
                                                        onChange={(e) => {
                                                            option.value = e.target.value;
                                                            setAttribute({ ...attribute })
                                                        }
                                                        }
                                                        placeholder={option.value ? "" : `Child Option ${j + 1}`}
                                                    />
                                                </div>
                                                {option.value && <DeleteIcon className={styles.deleteOption} onClick={() => {
                                                    parentOption.childOptions = parentOption.childOptions!.filter(x => x != option);
                                                    setAttribute({ ...attribute })
                                                }} />}
                                            </div>
                                        })}
                                        <div className={styles.addChildOption} onClick={() => {
                                            parentOption.childOptions?.push({ value: "" });
                                            setAttribute({ ...attribute })
                                        }}>
                                            Add Child Option +
                                        </div>
                                    </div>
                                </div>

                            }
                        )

                    }
                </div>
            </div>
        </div>
        <div className={styles.saveField}>
            <Button onClick={() => { props.onFieldSave(attribute) }} variant="secondary" text="Save Field" className={styles.saveFieldBtn} />
        </div>
    </div>
}